import { Constr, Data } from '@lucid-evolution/lucid';
import { concatUint8Arrays, intToUint8Array, itemToLucidData, objToLucidData, stringHexToUint8Array } from './index.exports';
import { FundCategory, OracleReIdx_Data, Oracle_Data, TokenWithAmountForDatum, TokensForInvestUnitDatum, TokensForInvestUnitWithDetails } from './types';

//--------------------------------------------------------

// export const serializeInvestUnitType = (value: InvestUnitType | undefined) => {
//     if (value === undefined) return undefined
//     let serialized: any = {};
//     serialized = JSON.parse(toJson(value));
//     for (let i = 0; i < value.iuValues.length; i++) {
//         serialized.iuValues[i] = [value.iuValues[i][0], value.iuValues[i][1], value.iuValues[i][2].toString()]
//     }
//     return serialized;
// };

export const deserealizeInvestUnitType = (value: any | undefined): TokensForInvestUnitDatum | undefined => {
    if (value === undefined) return undefined;
    const investUnitType: TokensForInvestUnitDatum = value;
    for (let i = 0; i < value.iuValues.length; i++) {
        investUnitType.iuValues[i] = [value.iuValues[i][0], value.iuValues[i][1], BigInt(value.iuValues[i][2])];
    }
    return investUnitType;
};

export const deserealizeInvestUnitTypeWithADAPrices = (value: any | undefined): TokensForInvestUnitWithDetails | undefined => {
    if (value === undefined) return undefined;
    const investUnitType: TokensForInvestUnitWithDetails = value;
    for (let i = 0; i < value.iuValuesWithDetailsAndAmount.length; i++) {
        investUnitType.iuValuesWithDetailsAndAmount[i] = {
            ...value.iuValuesWithDetailsAndAmount[i],
            amount: value.iuValuesWithDetailsAndAmount[i].amount !== undefined ? BigInt(value.iuValuesWithDetailsAndAmount[i].amount) : undefined,
            priceADAx1e6: value.iuValuesWithDetailsAndAmount[i].priceADAx1e6 !== undefined ? BigInt(value.iuValuesWithDetailsAndAmount[i].priceADAx1e6) : undefined,
            date: value.iuValuesWithDetailsAndAmount[i].date !== undefined ? BigInt(value.iuValuesWithDetailsAndAmount[i].date) : undefined,
        };
    }
    return investUnitType;
};

export const fromPlutusDataInvestUnitType = (lucidDataForConstr0: any | undefined) => {
    const iuValues: TokenWithAmountForDatum[] = [];
    if (lucidDataForConstr0?.index === 0) {
        const lucidDataForConstr0_fields = lucidDataForConstr0.fields;
        if (lucidDataForConstr0_fields.length === 1) {
            const lucidDataForConstr0_0 = lucidDataForConstr0_fields[0];
            for (let i = 0; i < lucidDataForConstr0_0.length; i++) {
                const lucidDataForConstr0_0_i = lucidDataForConstr0_0[i];
                if (lucidDataForConstr0_0_i.index === 0) {
                    const lucidDataForConstr0_0_i_fields = lucidDataForConstr0_0_i.fields;
                    const token: TokenWithAmountForDatum = lucidDataForConstr0_0_i_fields;
                    iuValues.push(token);
                } else {
                    throw `InvestUnitType - Can't get from Datum`;
                }
            }
            const objectInstance: TokensForInvestUnitDatum = { iuValues: iuValues };
            return objectInstance;
        } else {
            throw `InvestUnitType - Can't get from Datum`;
        }
    } else {
        throw `InvestUnitType - Can't get from Datum`;
    }
};

export const toPlutusDataInvestUnitType = (value: TokensForInvestUnitDatum | undefined): Data => {
    if (value === undefined) {
        throw `InvestUnitType - Can't get Plutus Data from undefined`;
    }
    const list = [];
    for (let i = 0; i < value.iuValues.length; i++) {
        const obj = objToLucidData(value.iuValues[i]);
        list.push(obj);
    }
    const res = new Constr(0, [list]);
    return res;
};

export const toPlutusDataOracleReIdx_Data = (value: OracleReIdx_Data | undefined): Data => {
    if (value === undefined) {
        throw `OracleReIdx_Data - Can't get Plutus Data from undefined`;
    }
    const list = [];
    const investUnitTypePlutusData = toPlutusDataInvestUnitType(value.oridTokensPriceADA);
    list.push(investUnitTypePlutusData);
    const timePlutusData = itemToLucidData(value.oridTime);
    list.push(timePlutusData);
    const res = new Constr(0, list);
    return res;
};

export const toPlutusDataOracle_Data = (value: Oracle_Data | undefined): Data => {
    if (value === undefined) {
        throw `Oracle_Data - Can't get Plutus Data from undefined`;
    }
    const list = [];
    const investUnitTypePlutusData = toPlutusDataInvestUnitType(value.odTokenFTPriceADA);
    list.push(investUnitTypePlutusData);
    const timePlutusData = itemToLucidData(value.odTime);
    list.push(timePlutusData);
    const res = new Constr(0, list);
    return res;
};

//--------------------------------------------------------

// export const serializeFundCategory = (value: FundCategory | undefined) => {
//     if (value === undefined) return undefined
//     const serialized: any = {
//         fcCategoryNumber: value.fcCategoryNumber,
//         fcRequiredTokenGov: value.fcRequiredTokenGov.toString(),
//         fcMaxUI: value.fcMaxUI.toString()
//     };
//     return serialized;
// };

export const deserealizeFundCategory = (value: any | undefined): FundCategory | undefined => {
    if (value === undefined) return undefined;
    const deserialized: FundCategory = {
        fcCategoryNumber: value.fcCategoryNumber,
        fcRequiredTokenGov: BigInt(value.fcRequiredTokenGov),
        fcMaxUI: BigInt(value.fcMaxUI),
    };
    return deserialized;
};

export const fundCategoryfromPlutusData = (lucidDataForDatum: any | undefined) => {
    if (lucidDataForDatum?.index === 0) {
        const lucidDataForConstr0 = lucidDataForDatum.fields;
        if (lucidDataForConstr0.length === 3) {
            const objectInstance: FundCategory = {
                fcCategoryNumber: Number(lucidDataForConstr0[0]),
                fcRequiredTokenGov: lucidDataForConstr0[1],
                fcMaxUI: lucidDataForConstr0[2],
            };
            return objectInstance;
        }
    }
    throw `FundCategory - Can't get from Datum`;
};

// export const fundValidatorHashAndVersionfromPlutusData = (lucidDataForDatum: any | undefined) => {
//     if (lucidDataForDatum?.index === 0) {
//         const lucidDataForConstr0 = lucidDataForDatum.fields
//         if (lucidDataForConstr0.length === 4) {
//             const objectInstance: FundFactory = {
//                 fvFundVersion: Number(lucidDataForConstr0[0]),
//                 fvFundValidator_Hash: lucidDataForConstr0[1],
//                 fvInvestUnitValidator_Hash: lucidDataForConstr0[2],
//             }
//             return objectInstance
//         }
//     }
//     throw `FundValidatorHashAndVersion - Can't get from Datum`
// };

// export const deserealizefundHoldingCreator = (value: any | undefined): HoldingCreator | undefined => {
//     if (value === undefined) return undefined;
//     const deserialized: HoldingCreator = {
//         hcPaymentPKH: value.hcPaymentPKH,
//         hcStakePKH: Maybe.fromPlainObject(value.hcStakePKH),
//         hcMinADA: BigInt(value.hcMinADA),
//     };
//     return deserialized;
// };

// export const fundHoldingCreatorfromPlutusData = (lucidDataForDatum: any | undefined) => {
//     if (lucidDataForDatum?.index === 0) {
//         const lucidDataForConstr0 = lucidDataForDatum.fields;
//         if (lucidDataForConstr0.length === 3) {
//             const objectInstance: HoldingCreator = {
//                 hcPaymentPKH: lucidDataForConstr0[0],
//                 hcStakePKH: Maybe.fromPlutusData(lucidDataForConstr0[1]),
//                 hcMinADA: lucidDataForConstr0[2],
//             };
//             return objectInstance;
//         }
//     }
//     throw `HoldingCreator - Can't get from Datum`;
// };

//--------------------------------------------------------

export function valueToUint8Array([cs, tn, amt]: TokenWithAmountForDatum): Uint8Array {
    // Assuming you have appropriate conversion functions for the currency symbol, token name, and integer to byte strings
    return concatUint8Arrays([stringHexToUint8Array(cs), stringHexToUint8Array(tn), intToUint8Array(amt)]);
}

export function investUnitToUint8Array(investUnit: TokensForInvestUnitDatum): Uint8Array {
    return investUnit.iuValues.reduce<Uint8Array>((acc: Uint8Array, value: TokenWithAmountForDatum) => concatUint8Arrays([acc, valueToUint8Array(value)]), new Uint8Array());
}

export function oracleReIdxDataToUint8Array(data: OracleReIdx_Data): Uint8Array {
    const oridTokensPriceADA_BBS = investUnitToUint8Array(data.oridTokensPriceADA);
    const oridTimeBBS = intToUint8Array(data.oridTime);
    return concatUint8Arrays([oridTokensPriceADA_BBS, oridTimeBBS]);
}

export function oracleDataToUint8Array(data: Oracle_Data): Uint8Array {
    const orTokenFTPriceADA_BBS = investUnitToUint8Array(data.odTokenFTPriceADA);
    const orTimeBBS = intToUint8Array(data.odTime);
    return concatUint8Arrays([orTokenFTPriceADA_BBS, orTimeBBS]);
}

//--------------------------------------------------------
